import React from 'react';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { FaSearch, FaFileAlt, FaCheck } from 'react-icons/fa';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const AppUsageCard = () => {
  const usageSteps = [
    {
      title: 'Search Text',
      description: 'Enter the text you want to summarize.',
      icon: <FaSearch size={60} color='#38B2AC' />,
    },
    {
      title: 'Generate Summary',
      description: "Click the 'Summarize' button to generate the summary.",
      icon: <FaFileAlt size={60}  color='#38B2AC' />,
    },
    {
      title: 'Receive Summary',
      description: 'Get the concise summary of your text in seconds.',
      icon: <FaCheck size={60}  color='#38B2AC'/>,
    },
  ];

  const stepAnimationVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Flex
      justify="center"
      align="center"
      mt={20}
      wrap={{ base: 'wrap', md: 'nowrap' }}
      spacing={4}
      style={{display:"flex",gap:"20px"}}
    >
      {usageSteps.map((step, index) => (
        <MotionBox
          key={index}
          borderWidth="1px"
          borderRadius="lg"
          overflow="hidden"
          p={6}
          boxShadow="md"
          width={{ base: '100%', sm: '300px', md: '300px' }}
          initial="hidden"
          animate="visible"
        
          variants={stepAnimationVariants}
          transition={{ duration: 0.5, delay: index * 0.2 }}
        >
          {step.icon}
          <Heading as="h3" size="md" mt={8} mb={4} >
            {step.title}
          </Heading>
          <Text color="gray.600">{step.description}</Text>
        </MotionBox>
      ))}
    </Flex>
  );
};

export default AppUsageCard;
